import Extract from './extract.vue'
import ListExtract from './list-extract.vue'
export default {
  path: '/extract',
  meta: {
    nav: {
      icon: 'dialpad',
      childDefault: true
    },
    breadCrumb: 'Extract'
  },
  component: Extract,
  children: [
    {
      path: '',
      name: 'extract',
      meta: {
        breadCrumb: 'List'
      },
      component: ListExtract
    }
  ]
}
